import React, { useEffect, useState } from 'react';
import styles from 'routes/adminMobile/pages/AdminMobileStatsDetail.module.css';
import { useLocation } from 'react-router-dom';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pagePaddTopH } from 'routes/adminMobile/constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import AdminMobileMonthSaleStat from 'routes/adminMobile/components/AdminMobileMonthSaleStat';
import AdminMobileYearSaleStat from 'routes/adminMobile/components/AdminMobileYearSaleStat';
import AdminMobileEachStoreBest from '../components/AdminMobileEachStoreBest';
import AdminMobileMoveBackBtn from '../components/common/AdminMobileMoveBackBtn';

const AdminMobileStatsDetail = () => {
    const location = useLocation();
    const [storeData, setStoreData] = useState(null);

    useEffect(() => {
        if (location.state && location.state.storeData) {
            const receivedStoreData = location.state.storeData;
            
            setStoreData(receivedStoreData);
        } else {
            
        }
    }, [location.state]);

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 해당 점포 월간 판매량 */}
                        <AdminMobileMonthSaleStat storeData={storeData} />
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 해당 점포 연간 판매량 합계 */}
                        <AdminMobileYearSaleStat storeData={storeData} />
                    </FlexChild>
                    <FlexChild>
                        {/* 해당 점포 판매량 BEST */}
                        <AdminMobileEachStoreBest storeData={storeData} />
                    </FlexChild>
                </VerticalFlex>
                {/* 뒤로 가기 이동 버튼 */}
                <AdminMobileMoveBackBtn />
            </Container>
        </div>
    );
};

export default AdminMobileStatsDetail;